export const defaultState = {
  items: {},
  categories: {},
  categoryOrder: [],
  online: false,
  token: "",
};
